import { TransactionsFilterStateProps } from "../financial.types";
import { TransactionStatus } from "./enums";

export const EMPTY_TRANSACTIONS_FILTER_FORM_VALUES: TransactionsFilterStateProps =
  {
    statuses: [],
    dateRange: null,
    transactionTotalFrom: undefined,
    transactionTotalTo: undefined
  };

export const STATUS_FILTER_SEARCH_PARAMETER = "statuses";
export const DATE_RANGE_FILTER_SEARCH_PARAMETER = "dateRange";
export const TOTAL_FROM_FILTER_SEARCH_PARAMETER = "transactionTotalFrom";
export const TOTAL_TO_FILTER_SEARCH_PARAMETER = "transactionTotalTo";

export const TRANSACTION_ID_SEARCH_PARAMETER = "transactionId";

export const TRANSACTIONS_STATUSES_LIST = [
  {
    label: "Payment Collected",
    value: TransactionStatus.PaymentCollected,
    backgroundColor: "#16C350"
  },
  {
    label: "Earnings Sent",
    value: TransactionStatus.EarningsSent,
    backgroundColor: "#FF9900"
  },
  {
    label: "Collected By Admin",
    value: TransactionStatus.CashCollectedFromDriver,
    backgroundColor: "#16C350"
  },
  {
    label: "Collected By Driver",
    value: TransactionStatus.CashCollectedFromCustomer,
    backgroundColor: "#FB3973"
  },
  {
    label: "Refund Sent",
    value: TransactionStatus.Refunded,
    backgroundColor: "#FF0000"
  }
];
